import z from 'zod';

export const GlobalAlertResponseSchema = z
  .object({
    id: z.number(),
    text: z.string(),
  })
  .optional();
